import Swal from "sweetalert2/dist/sweetalert2.js";

/*Profile*/
if (window.location.pathname.includes("placement/edit")
    || window.location.pathname.includes("placement/create")){

    app.child_clone = {
        "create_url":"/api/child/create",
        "create_data":{
            "policyholder_id":app_data.placement.policyholder.id
        },
        "delete_url":"/api/child/delete",
        "arr":"placement.policyholder.children",
        "model": app.models.child
    };

    $(window).on("popup_close", function(e, type) {
        $(".update-alert").popover("hide");
        $(".complete-alert").popover("hide");
        $(".delete-alert").popover("hide");
        if (type === 'editor-placement_user_alerts') window.app_methods.getAlertSummary();
    });

    $(window).on("popup_open", function(e, type, opts) {
        if (type !== "editor-placement_user_alerts") return;

        const el = $(opts.el);
        const placementId = el.attr('data-placement_id');
        const userId = el.attr('data-user_id');
        window.app_methods.getAlerts(placementId, userId);
    });

    $(window).on("confirm.bs.popover", function(e, popover, confirm){
        var ele = $(popover.element);
        if(confirm && ele.hasClass("complete-alert")) {
            window.app_methods.completeAlert(ele.hasClass("skip-log"));
        } else if(confirm && ele.hasClass("update-alert")) {
            window.app_methods.updateAlert(ele.hasClass("skip-log"));
        } else if(confirm && ele.hasClass("delete-alert")) {
            window.app_methods.deleteAlert();
        }
        ele.popover("dispose");
    });

    $(window).on("/api/placement_contact/update.success", function(e, data){
        for(let type_id in data.history){
            app.$set(app.contact_history, type_id, data.history[type_id]);
        }
    });

    $(window).on("/api/placement/update.success", function(e, data){
        if(typeof Swal.getConfirmButton() !== 'undefined'
        && Swal.getConfirmButton() !== null) Swal.clickConfirm();

        // if(data.updated.lost_file == data.before_update.lost_file || !data.updated.lost_file) return;

        // Swal.queue([{
        //     type: 'info',
        //     title: "Select An Accountant",
        //     html: `
        //     <form id="accountant_select" action="/api/placement/update" method="POST">
        //         <div class="form-group">
        //             <v-select name="user_id" v-model="placement.user_id" :options="accountants">
        //             </v-select>
        //         </div>
        //         <input type="hidden" v-model="placement.id" name="id" />
        //         <input type="hidden" v-model="placement.policyholder.name" name="policyholder[name]" />
        //         <input type="hidden" v-model="placement.company_id" name="company_id" />
        //         <input type="checkbox" class="d-none" v-model="placement.claim_tbd" name="claim_tbd" />
        //         <input type="hidden" v-model="placement.claim_number" name="claim_number" />
        //         <button class="btn btn-primary mt-2">Submit</button>
        //     </form>
        //     `,
        //     showConfirmButton: false,
        //     allowOutsideClick: false,
        //     onBeforeOpen: () => {

        //         const content = Swal.getContent()
        //         const $ = content.querySelector.bind(content)

        //         new Vue({
        //             el: "#accountant_select",
        //             data: () => ({
        //                 placement: app.placement,
        //                 accountants: app.accountants
        //             }),
        //             watch:{
        //                 "placement.user_id"(){
        //                     app.placement.user_id = this.placement.user_id
        //                 }
        //             }
        //         });

        //     }
        // }]);
    });

    $(window).on('/api/placement/update.error', function (response) {
        // message('Error form', 1)
    });

    $(window).on("/api/note/create.success", function(e, response, form){
        form[0].reset();
        app.leave_note = '';
        app.notes.unshift(response['note']);
    });

    // Echo.private(`placement.${app.placement.id}.notes`)
    //     .listen('NoteChange', (e) => {
    //         app.notes = e.notes;
    //     });

    let autocomplete;

    function init_autocomplete() {
        let input = document.getElementById('address-autocomplete');
        let options = {
            types: ['address']
        };

        autocomplete = new google.maps.places.Autocomplete(input, options);
        autocomplete.setFields(['address_components', 'geometry']);

        let mutationObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === "autocomplete") {
                    $('#address-autocomplete').attr("autocomplete", "new-password");
                    mutationObserver.disconnect();
                }
            });
        });

        mutationObserver.observe(document.querySelector('#address-autocomplete'), {
            attributes: true
        });

        var componentForm = {
            street_number: {
                "name": 'short_name',
                "value": ""
            },
            route: {
                "name": 'long_name',
                "value": ""
            },
            locality: {
                "name": 'long_name',
                "value": ""
            },
            administrative_area_level_1: {
                "name": 'long_name',
                "value": ""
            },
            country: {
                "name": 'long_name',
                "value": ""
            },
            postal_code: {
                "name": 'short_name',
                "value": ""
            }
        };

        autocomplete.addListener('place_changed', function () {
            let place = autocomplete.getPlace();
            if (!place.geometry) return;
            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0];
                if (componentForm[addressType]) {
                    let val = place.address_components[i][componentForm[addressType]["name"]];
                    componentForm[addressType]["value"] = val;
                }
            }

            let display = $('#address-autocomplete').closest('form');
            let state = app_options.states.find(function (option) {
                return option.text == componentForm['administrative_area_level_1']['value']
            }).id;

            app.placement.loss_address.full_address = $(input).val();
            app.placement.loss_address.address.address = componentForm['street_number']['value'] + " " + componentForm['route']['value'];
            app.placement.loss_address.address.city = componentForm['locality']['value'];
            app.placement.loss_address.address.state_id = state;
            app.placement.loss_address.address.state.name = componentForm['administrative_area_level_1']['value'];
            app.placement.loss_address.address.zip = componentForm['postal_code']['value'];

            let location = place.geometry.location;
            app.placement.loss_address.address.latitude = location.lat();
            app.placement.loss_address.address.longitude = location.lng();

            // Update miles of available properties/frv properties from loss address
            $('#propertyList span').each(function (index, element) {
                let inputLatName, inputLngName, inputDistanceName;

                if (!$(element).hasClass('is-frv')) {
                    inputLatName = 'input[name="properties[lat][]"]';
                    inputLngName = 'input[name="properties[lng][]"]';
                    inputDistanceName = 'input[name="properties[miles_from_loss][]"]';
                } else {
                    inputLatName = 'input[name="frv_properties[lat][]"]';
                    inputLngName = 'input[name="frv_properties[lng][]"]';
                    inputDistanceName = 'input[name="frv_properties[distance][]"]';
                }

                let origin = location;
                let lat = $(element).find(inputLatName).val();
                let lng = $(element).find(inputLngName).val();
                let destination = new google.maps.LatLng(lat, lng);
                let service = new google.maps.DistanceMatrixService();

                service.getDistanceMatrix({
                    origins: [origin],
                    destinations: [destination],
                    travelMode: 'DRIVING',
                    unitSystem: google.maps.UnitSystem.IMPERIAL
                }, function (response, status) {
                    if (status!=='OK') return;
                    if (identify(response).rows[0].elements[0].distance(false) != false) {
                        let distance = response['rows'][0]['elements'][0]['distance'];
                        var value = distance.value * 0.000621371192;
                        $(element).find(inputDistanceName).val(parseFloat(value).toFixed(2));
                    } else {
                        let distance = parseFloat(getDistance(origin, destination));
                        $(element).find(inputDistanceName).val(
                            distance.toFixed(2)
                        );
                    }
                });
            });

            display.find("[name='address[address]']").trigger("update");
        });
    }

    $(function () {
        window.app_methods.getAlertSummary();

        if (typeof window.maps_loaded !== 'undefined') {
            init_autocomplete();
        } else {
            window.initMap = init_autocomplete;
        }
    });
}


if (window.location.pathname.includes("placement/")){
    $(window).on("/api/placement/update.success", function(e, data){
        if (data.updated && data.before_update && data.updated.archived != data.before_update.archived) {
            window.location.reload();
        }
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/placement.js